// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import getColor from "@insite/mobius/utilities/getColor";
import { ProductListProductGridCardStyles } from "@rugby/Overrides/Widgets/ProductList/ProductListProductGridCard";
import customProductListActionsStyle from "@rugby/Overrides/Widgets/ProductList/styles/ProductListActions.style";
import customProductCardStyles from "@rugby/Overrides/Widgets/ProductList/styles/ProductListProductCard.styles";
import { css } from "styled-components";

type StyleProps = ProductListProductGridCardStyles & {
    brands: any;
    productImage: any;
    qtyAndAddToCartContainer: any;
    compareAndAddToCartContainer: any;
};

const gapItems = 10;

const customProductGridCardCustomStyle: StyleProps = {
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 100%;
            max-width: 274px;
            height: 100%;

            overflow: hidden;
            padding-bottom: 10px;

            background: ${getColor("common.white")};
            border: 1px solid ${getColor("common.border")};
        `,
    },
    brands: {
        wrapper: {
            css: css`
                width: 100%;
                height: 48px;
                min-height: 48px;
                padding: 10px;
                border-bottom: 1px solid ${getColor("common.border")};
            `,
        },
        linkWrappingImage: {
            css: css`
                width: 100%;
                height: 100%;
            `,
        },
        image: {
            css: css`
                width: 100%;
                align-items: flex-start;

                img {
                    width: auto;
                    height: auto;
                    max-width: 100%;
                    max-height: 100%;
                    position: absolute;
                    top: 50%;
                    transform: translate(0, -50%);
                }
            `,
        },
    },
    productImage: {
        container: {
            css: css`
                ${customProductCardStyles.productListProductImage.wrapper.css}
                // override "CardList Image style"
                margin-right: 0;
                height: 198px;

                // Additional style
                position: relative;
                &:after {
                    content: "";
                    position: absolute;
                    width: calc(100% - 20px * 2);
                    height: 1px;
                    background: ${getColor("common.border")};
                    transform: translateX(-50%);
                    left: 50%;
                    bottom: 0;
                }
            `,
        },
        productListProductImage: {
            ...customProductCardStyles.productListProductImage,
        },
    },
    productInfoContainer: {
        css: css`
            display: flex;
            flex-direction: column;

            &&& > div {
                margin-bottom: 10px;
                &:last-child {
                    margin-bottom: 0;
                }
            }
            padding: 20px 20px 0 20px;
            height: 100%;
        `,
    },
    actionsContainer: {
        css: css`
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 100%;

            &.qtyAndAddToCartSection {
                margin-top: auto;
                height: initial;
            }

            &&& > div {
                margin-bottom: 10px;
                &:last-child {
                    margin-bottom: 0;
                }
            }
        `,
    },
    priceAndAvailabilityContainer: {
        wrapper: {
            css: css`
                display: block;
                overflow: hidden;

                .productAvailabilityContainer {
                    height: 100%;
                }
            `,
        },
        price: {
            wrapper: {
                css: css`
                    ${customProductListActionsStyle.wrapper?.css}
                    width: auto;
                    height: auto;
                    min-width: 98px;
                `,
            },
        },
        availability: {
            container: {
                gap: 0,
                css: css`
                    flex-grow: 0;
                    width: auto;
                `,
            },
            messageGridItem: {
                width: 12,
                css: css`
                    flex-basis: auto;
                    width: auto;
                `,
            },
        },
    },
    qtyAndAddToCartContainer: {
        wrapper: {
            css: css`
                ${customProductListActionsStyle.wrapper?.css}
                height: auto;
            `,
        },
        addToCartWrapper: {
            css: css`
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
                margin-top: 2px;
            `,
        },
        quantityOrderedWrapper: {
            css: css`
                flex: 1;
                display: flex;
                max-width: none;
                width: auto;
                flex-grow: 0;
            `,
        },
        addToCartButton: {
            css: css`
                padding: 0;
                flex: 2;
                max-width: 160px;
                & {
                    font-size: 15px;
                }
            `,
        },
    },
    compareAndAddToCartContainer: {
        ...customProductCardStyles.subInformationWrapper.compareAndAddToCartContainer,
        wrapper: {
            css: css`
                flex-direction: row;
                justify-content: space-between;
                display: inline-flex;
                flex-wrap: wrap;
                margin-top: 2px;
            `,
        },
    },
};

export default customProductGridCardCustomStyle;
